import { render, staticRenderFns } from "./AdminProviderOffer.vue?vue&type=template&id=58c5e462&scoped=true&"
import script from "./AdminProviderOffer.vue?vue&type=script&lang=ts&"
export * from "./AdminProviderOffer.vue?vue&type=script&lang=ts&"
import style0 from "./AdminProviderOffer.vue?vue&type=style&index=0&id=58c5e462&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c5e462",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
